import { KNOWLEDGE_CATEGORY_KEY_PATTERN, type KnowledgePartition } from "@usales/contract/values";

export type KnowledgePage = KnowledgePartition | "all";
const PREFIX = "#knowledge/";
const listeners = new Set<() => void>();

export function getKnowledgePage(): KnowledgePage | undefined {
  const hash = window.location.hash;
  if (!hash.startsWith(PREFIX)) return undefined;
  const key = hash.slice(PREFIX.length);
  // 分类由企业自己建:这里只认形状,这家企业有没有这个分类由页面按分类表判断
  return key === "all" || new RegExp(KNOWLEDGE_CATEGORY_KEY_PATTERN).test(key) ? key as KnowledgePage : undefined;
}

const notify = (): void => { for (const listener of listeners) listener(); };

export function subscribeKnowledgePage(listener: () => void): () => void {
  if (!listeners.size) { window.addEventListener("popstate", notify); window.addEventListener("hashchange", notify); }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (!listeners.size) { window.removeEventListener("popstate", notify); window.removeEventListener("hashchange", notify); }
  };
}

/** Category pages share the mounted library, so navigation keeps upload drafts and filters. */
export function openKnowledgePage(page?: KnowledgePage, replace = false): void {
  if (page === getKnowledgePage()) return;
  const url = `${window.location.pathname}${window.location.search}${page ? `${PREFIX}${page}` : ""}`;
  if (replace) window.history.replaceState(null, "", url);
  else window.history.pushState(null, "", url);
  notify();
}
